import { render } from "./DashboardView.vue?vue&type=template&id=f32eb86c"
import script from "./js/dashboardView.js?vue&type=script&lang=js&external"
export * from "./js/dashboardView.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__